export default "__VITE_ASSET__B7234gxa__"